import { FilterTypeEnum } from '@creditsights/api-ui-web';
import { TableViewConfig } from '@creditsights/styleguide-web';
import { Filter } from '../../../../models';
import CheckboxCellRenderer, {
  CheckboxCellRendererProps,
} from '../../../../components/formatters/CheckboxCellRenderer/CheckboxCellRenderer';
import { IssuerListItemDto } from '../../../../services/dtos/issuer/issuerList.dto';
import { getIssuerRoute } from '../../../../utils/navigationUtils';
import CompanyLinkRenderer from './CellRenderers/CompanyLinkRenderer/CompanyLinkRenderer';
import TagsRenderer from './CellRenderers/TagsRenderer/TagsRenderer';

export const sortIssuers = (issuers: IssuerListItemDto[]): IssuerListItemDto[] => {
  return Array.from(issuers?.values()).sort(
    (a, b) => new Date(b.latestRec?.publishDate ?? 0).valueOf() - new Date(a.latestRec?.publishDate ?? 0).valueOf()
  );
};

export const columnsConfig = (
  cellClassname: string,
  tags: Filter[] | undefined,
  checkboxCellProps: CheckboxCellRendererProps
): TableViewConfig => {
  return {
    columns: [
      {
        dataKey: 'deleteCheckbox',
        width: '2.8rem',
        cellDataRenderer: CheckboxCellRenderer,
        headerCellRenderer: CheckboxCellRenderer,
        cellRendererProps: checkboxCellProps,
      },
      {
        dataKey: 'displayName',
        headerName: 'Issuer',
        cellDataRenderer: CompanyLinkRenderer,
        cellRendererProps: {
          getLink: (item: IssuerListItemDto) => getIssuerRoute(item.tagId),
          isOpenInNewTab: false,
        },
        maxWidth: '21.4rem',
      },
      {
        dataKey: 'displayTicker',
        headerName: 'Identifiers',
        cellClassname,
      },
      {
        dataKey: 'implied',
        headerName: 'Sector',
        cellDataRenderer: TagsRenderer(FilterTypeEnum.sector),
        cellRendererProps: { tags },
        cellClassname,
        uniqueDataKey: 'sector',
      },
      {
        dataKey: 'implied',
        headerName: 'Region',
        cellDataRenderer: TagsRenderer(FilterTypeEnum.region),
        cellRendererProps: { tags },
        cellClassname,
        uniqueDataKey: 'region',
      },
      {
        dataKey: 'implied',
        headerName: 'Credit Grade',
        cellDataRenderer: TagsRenderer(FilterTypeEnum.creditGrade),
        cellRendererProps: { tags },
        cellClassname,
        uniqueDataKey: 'creditGrade',
      },
    ],
  };
};
